
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

import type { SettingsItemIcon } from '@xt/client/entities/user/types.d'

@Observer
@Component({
  components: {}
})
export default class SettingsItem extends Vue {
  @Prop() icon: SettingsItemIcon

  @Prop({ required: true }) title: string

  @Prop({ required: true }) description: string

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
